enum DealBrandErrorCode {
  BrandEmptyField = "PBBrandEmptyField",
  BrandNotFound = "PBBrandNotFound",
  BrandParentNotFound = "PBBrandParentNotFound",
  BrandAlreadyExists = "PBBrandAlreadyExists",
  BrandNotParent = "PBBrandNotParent",
  BrandInvalid = "PBBrandInvalid",
  BrandParentToVariant = "PBBrandParentToVariant"
}

export default DealBrandErrorCode
